<template>
  <div class="success-modal">
    <div class="anim">
      <div class="container">
        <i class="el-icon-loading"></i>
      </div>
    </div>
    <div class="info">
      <div class="title">Payment Processing...</div>
      <div>Please do not close this window and wait for verify process</div>
    </div>
    <div id="autoForm">
      <form ref="formACS" :action="ACSURL" method="POST">
        <input type="text" name="PaReq" :value="PAReq" /> 
        <input type="text" name="TermUrl" :value="callbackURL" />
        <input type="text" name="MD" :value="MD" />
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ACSURL: '',
      PAReq: '',
      MD: '',
      callbackURL: '',
      token: ''
    };
  },
  methods: {
    get3DData(){
      const data = this.$route.params
      this.ACSURL = data.acsurl;
      this.PAReq = data.PAReq;
      this.MD = data.MD;
      this.token = data.token;
      this.callbackURL = process.env.VUE_APP_SERVER_BASE_API + '/api/payment/secure?token=' + data.token;
    },
  },
  created() {
    this.get3DData();
  },
  mounted() {
    this.$refs.formACS.submit();
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:400,500,600,700|Source+Sans+Pro:400,600,700&display=swap");
body {
  background: #ddeefc;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
}
.success-modal {
  position: absolute;
  width: 500px;
  height: 230px;
  background-color: #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.2);
}

.success-modal .container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 4rem;
  color: #ffffff;
}

.success-modal .anim {
  height: 120px;
  text-align: center;
  background-color: #3fc59d;
  position: relative;
}
.success-modal .info {
  padding: 30px;
  color: #3b475e;
}
.success-modal .info .title {
  font-weight: 900;
  font-size: 2rem;
  margin-bottom: 10px;
}

.success-modal .info table {
  width: 100%;
}
.success-modal .info table tr td {
  padding: 6px;
}
.success-modal .info .btn-area {
  margin: 20px;
}

.left-side {
  text-align: left;
}

.right-side {
  text-align: right;
  font-weight: 900;
}

@media only screen and (max-width: 767px) {
  .success-modal {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
